// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__2_Mj-","requiredAsterisk":"Info_requiredAsterisk__zl9zL"};